"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviourWeekOverview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const react_i18next_1 = require("react-i18next");
const typography_1 = require("../../shared/typography");
const mark_boolean_value_1 = require("../../molecules/mark-boolean-value");
const useRWD_1 = __importDefault(require("../../shared/hooks/useRWD"));
exports.BehaviourWeekOverview = (0, react_1.memo)(({ values, onHeaderClick }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile } = (0, useRWD_1.default)();
    if (isMobile) {
        return ((0, jsx_runtime_1.jsxs)(Mobile, { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { onClick: onHeaderClick, "data-cy": "behaviour-overview-header", children: t("behavior.weekOverview.title") }, void 0), (0, jsx_runtime_1.jsx)("div", { children: Array.from(values.keys()).map((day) => {
                        const { shouldShow, value } = values.get(day);
                        return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: day }, void 0), shouldShow && (0, jsx_runtime_1.jsx)(mark_boolean_value_1.MarkBooleanValue, { value: value, size: "sm" }, void 0)] }, day));
                    }) }, void 0)] }, void 0));
    }
    return ((0, jsx_runtime_1.jsxs)(Desktop, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { onClick: onHeaderClick, "data-cy": "behaviour-overview-header", children: t("behavior.weekOverview.title") }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.P, {}, void 0), Array.from(values.keys()).map((day) => ((0, jsx_runtime_1.jsx)(typography_1.P, { children: day }, day)))] }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: t("behavior.weekOverview.subTitle") }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", {}, void 0), Array.from(values.values()).map(({ shouldShow, value }, idx) => ((0, jsx_runtime_1.jsx)("div", { children: shouldShow && (0, jsx_runtime_1.jsx)(mark_boolean_value_1.MarkBooleanValue, { value: value, size: "sm" }, void 0) }, idx)))] }, void 0)] }, void 0)] }, void 0));
});
const Desktop = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};

  h2,
  p {
    margin-bottom: 0;
  }

  & > div:first-of-type {
    border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};

    p {
      color: ${({ theme }) => theme.colors.greyBase};
    }
  }

  & > div {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};

    & > h2,
    & > p {
      line-height: 1.5rem;
      flex: 3;
    }

    & > h2 {
      cursor: pointer;
    }

    & > div {
      align-items: center;
      display: flex;
      flex: 8;
      justify-content: space-between;

      & > div,
      & > p {
        display: flex;
        flex: 1;
        justify-content: center;
      }
    }
  }
`;
const Mobile = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-top: 1px solid ${({ theme }) => theme.colors.silverBase};

  h2 {
    border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
    padding: ${({ theme }) => theme.spacings.m};
  }

  p {
    color: ${({ theme }) => theme.colors.greyBase};
    margin-bottom: 0;
  }

  & > div {
    line-height: 1.5rem;
    padding: ${({ theme }) => `0 ${theme.spacings.m}`};

    & > div {
      align-items: center;
      display: flex;
      justify-content: space-between;
      padding: ${({ theme }) => `${theme.spacings.xs} 0`};
    }

    & > div:last-of-type {
      padding-bottom: ${({ theme }) => theme.spacings.m};
    }

    & > div:not(:last-of-type) {
      border-bottom: 1px solid
        ${({ theme }) => theme.colors.silverLighten70};
    }
  }
`;
//# sourceMappingURL=index.js.map